import { formatFormDate } from '@general/js/utils';
import { OperationType } from '@/enums';
import isEqual from 'lodash.isequal';

// eslint-disable-next-line import/prefer-default-export
export const mapEligibilityObj = (initialEligibility, currentEligibility, eligibilityType) => {
  currentEligibility.declarationExpiryDate = formatFormDate(currentEligibility.declarationExpiryDate);
  currentEligibility.declarationDate = formatFormDate(currentEligibility.declarationDate);

  // Compare Eligibility data without declarationDate and declarationExpiryDate field
  const initialData = { ...initialEligibility };
  delete initialData.declarationDate;
  delete initialData.declarationExpiryDate;

  const currentData = { ...currentEligibility };
  delete currentData.declarationDate;
  delete currentData.declarationExpiryDate;

  const op = !isEqual(initialData, currentData) ? OperationType.REPLACE : OperationType.NONE;

  const eligibilityObject = {
    op,
    eligibilityType,
    eligibilitySubject: currentEligibility.serviceConnection,
    subjectName: currentEligibility.serviceConnectionName,
    subjectRank: currentEligibility.veteranInfo?.rank ?? '',
    subjectRelation: currentEligibility.relationship ?? '',
    subjectDepartmentOrCompanyName:
      // as "veteranInfo" without veteran card is undefined then we need to check against undefined and '' then assign the value to "subjectDepartmentOrCompanyName"
      !currentEligibility.veteranInfo?.serviceAgency || currentEligibility.veteranInfo?.serviceAgency === ''
        ? currentEligibility.connectionName
        : currentEligibility.veteranInfo?.serviceAgency,
    subjectEligibilityType: currentEligibility.connectionType ?? '',
    subjectServiceType:
      !currentEligibility.veteranInfo?.serviceType || currentEligibility.veteranInfo?.serviceType === ''
        ? currentEligibility.connectionType
        : currentEligibility.veteranInfo?.serviceType,
    enlistmentDate: formatFormDate(currentEligibility.enlistmentDate),
    dischargeDate: formatFormDate(currentEligibility.dischargeDate),
    sercatStatus: currentEligibility.sercatStatus ?? '',
    workConnectionName: currentEligibility.relationName ?? '',
    declarationDate: formatFormDate(currentEligibility.declarationDate),
    expiryDate: formatFormDate(currentEligibility.declarationExpiryDate),
    declarationIsConfirmed: currentEligibility.declaration,
  };

  return eligibilityObject;
};
